import React from 'react';
import PropTypes from 'prop-types';

const TrainingItemBuilder = ({ item, index, onChange, onDelete, onEdit, moduleId }) => {
  const isVideo = item.type === 'TrainingVideo';

  return (
    <div className="training-item-builder p-3">
      <div className={`d-flex justify-content-between ${isVideo ? 'align-items-center' : 'align-items-start'}`}>
        <div className="flex-grow-1">
          <div className="d-flex align-items-center">
            {isVideo ? (
              <>
                <i className="fa fa-video-camera text-primary mr-2"></i>
                <strong>{item.title || 'Untitled Video'}</strong>
                {item.length && (
                  <span className="badge badge-info ml-2">{item.length}</span>
                )}
              </>
            ) : (
              <>
                <i className="fa fa-question-circle text-success mr-2"></i>
                <strong>{item.content ? (item.content.length > 60 ? `${item.content.substring(0, 60)}...` : item.content) : 'New Question'}</strong>
                <span className="badge badge-secondary ml-2">
                  {item.question_type === 'true_false' ? 'True/False' : 'Multiple Choice'}
                </span>
                <span className="badge badge-primary ml-2">{item.points || 1} pt</span>
              </>
            )}
          </div>

          {isVideo && item.content && (
            <div className="mt-2">
              <small className="text-muted">
                {item.content}
              </small>
            </div>
          )}

          {!isVideo && item.question_type === 'multiple_choice' && item.options && (
            <div className="mt-2">
              <small className="text-muted">Options:</small>
              <ul className="mb-0">
                {item.options.map((option, idx) => (
                  <li key={idx}>
                    <small className={option === item.correct_answer ? 'text-success font-weight-bold' : ''}>
                      {option}
                      {option === item.correct_answer && ' ✓'}
                    </small>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {!isVideo && item.question_type === 'true_false' && (
            <div className="mt-2">
              <small className="text-muted">
                Correct Answer: <span className="text-success font-weight-bold">{item.correct_answer}</span>
              </small>
            </div>
          )}
        </div>

        <div className="ml-3">
          <button
            type="button"
            className="btn btn-sm btn-outline-primary mr-1"
            onClick={() => onEdit(index)}
            title="Edit item"
          >
            <i className="fa fa-pencil"></i>
          </button>
          <button
            type="button"
            className="btn btn-sm btn-danger"
            onClick={() => onDelete(index)}
            title="Delete item"
          >
            <i className="fa fa-trash"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

TrainingItemBuilder.propTypes = {
  item: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  moduleId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default TrainingItemBuilder;
